import {PATH_BASED_SHAPES} from '../modelerX6/constants';

/**
 * После undo/redo по attrs (текст подписи узла из History) — обновить viewElement/concept и
 * отправить updateElementLabel в сокет (иначе откат только на графе).
 */
export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const pushLabelPatch = cellId => {
			const cell = graph.getCellById?.(cellId) ?? graph.model?.getCellById?.(cellId);
			if (!cell || typeof cell.isNode !== 'function' || !cell.isNode()) return;
			const raw = cell.getAttrByPath?.('label/text');
			const newText = typeof raw === 'string' ? raw : String(raw ?? '');
			const viewElement = modeler._findViewElementById?.(cellId);
			if (viewElement) {
				viewElement.label = newText;
				const elementRef = modeler._getElementRef?.(viewElement);
				if (elementRef && typeof elementRef.name !== 'undefined') {
					if (elementRef.set) elementRef.set('name', newText);
					else elementRef.name = newText;
				}
			}
			onPatch({
				patches: [
					{
						op: 'updateElementLabel',
						viewIndex: VIEW_INDEX,
						identifier: cellId,
						elementName: newText,
					},
				],
			});
			const sh = cell.getShape?.() ?? cell.shape;
			if (PATH_BASED_SHAPES.includes(sh) && modeler._nodeFactory?.update) {
				modeler._nodeFactory.update(cell, {label: newText});
			}
		};

		/**
		 * @param {unknown} cmd
		 * @returns {boolean}
		 */
		const isAttrsNodeLabelCmd = cmd => {
			if (!cmd || typeof cmd !== 'object') return false;
			const ev = cmd.event;
			const data = cmd.data;
			if (!data || data.key !== 'attrs') return false;
			if (ev !== 'cell:change:attrs') return false;
			const id = data.id;
			if (!id) return false;
			const cell = graph.getCellById?.(id) ?? graph.model?.getCellById?.(id);
			return !!(cell && cell.isNode?.());
		};

		const walk = (cmds, fn) => {
			if (!cmds) return;
			for (const c of cmds) {
				if (Array.isArray(c)) walk(c, fn);
				else fn(c);
			}
		};

		const onHistoryUndoRedo = ({cmds}) => {
			if (modeler._applyingPatch) return;
			walk(cmds, cmd => {
				if (isAttrsNodeLabelCmd(cmd)) pushLabelPatch(cmd.data.id);
			});
		};

		graph.on('history:undo', onHistoryUndoRedo);
		graph.on('history:redo', onHistoryUndoRedo);

		return () => {
			graph.off('history:undo', onHistoryUndoRedo);
			graph.off('history:redo', onHistoryUndoRedo);
		};
	},
};
